import React from "react";
import Button from "@mui/material/Button";
import { ButtonGroup, createTheme, ThemeProvider } from "@mui/material";

import useWindowDimensions from "../hooks/useWindowDimensions";
import useTheme from "../hooks/useTheme";
import { FilterType } from "../types/types";

export default function AllFilter(props: {
  filter: FilterType;
  onChange: (filter: FilterType) => void;
  style?: React.CSSProperties;
}) {
  const { isSmallLayout } = useWindowDimensions();

  const theme = useTheme();

  const muiTheme = createTheme({
    typography: {
      fontFamily: ["WixMadeforText"].join(","),
    },
  });

  const styles: {
    allFilter: React.CSSProperties;
  } = {
    allFilter: {
      borderStyle: "solid",
      height: isSmallLayout ? 30 : 60,
      width: isSmallLayout ? 50 : 80,
      backgroundColor: theme.buttonBackgroundColor,
      borderColor:
        props.filter.erp === undefined && props.filter.platform === undefined
          ? theme.selectedColor
          : "black",
      borderWidth:
        props.filter.erp === undefined && props.filter.platform === undefined
          ? theme.selectedBorderWidth
          : 0.2,
    },
  };

  return (
    <div style={props.style}>
      <ThemeProvider theme={muiTheme}>
        <ButtonGroup
          variant="contained"
          aria-label="outlined primary button group"
        >
          <Button
            variant="contained"
            onClick={() => {
              props.onChange({ erp: undefined, platform: undefined });
            }}
            style={styles.allFilter}
          >
            <h2 style={{ color: theme.textColor }}>{"all"}</h2>
          </Button>
        </ButtonGroup>
      </ThemeProvider>
    </div>
  );
}
